import NewViewExperience from '../../components/list/NewViewExperience'
import {SavedViewIssueList} from '../../components/views/SavedViewIssueList'
import {type PreviewQueryContextValue, PreviewQueryProvider} from '../../contexts/PreviewQueryContext'

type RepositoryViewNewPreviewProps = {
  owner: string
  repo: string
  query: string
  previewQueryContextValue: PreviewQueryContextValue
}

export function RepositoryViewNewPreview({
  owner,
  repo,
  query,
  previewQueryContextValue,
}: RepositoryViewNewPreviewProps) {
  if (!query) {
    return <NewViewExperience />
  }

  return (
    <PreviewQueryProvider value={previewQueryContextValue}>
      <SavedViewIssueList owner={owner} repo={repo} query={query} preheatEnabled={false} />
    </PreviewQueryProvider>
  )
}
